import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { Button, Paragraph, Heading } from 'react-magma-dom';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  Link,
  Button,
  Paragraph,
  Heading,
  LeadParagraph,
  React
};